import { render, staticRenderFns } from "./VkRecaptcha.vue?vue&type=template&id=66a6476c&scoped=true&"
import script from "./VkRecaptcha.vue?vue&type=script&lang=ts&"
export * from "./VkRecaptcha.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a6476c",
  null
  
)

export default component.exports